import React from "react";
import { useStoreHook } from "../../store";

const Backdrop = () => {
  const isLoading = useStoreHook((state) => state.api.loading);

  if (!isLoading) return null;

  return (
    <div className="modals-parent">
      <div className="bg-overlay" />
    </div>
  );
};

export default Backdrop;
